import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
// https://formly.dev/examples/bootstrap-specific/bootstrap-horizontal
@Component({
  selector: 'enauka-formly-horizontal-wrapper',
  templateUrl: './formly-horizontal-wrapper.component.html',
  styleUrls: ['./formly-horizontal-wrapper.component.css']
})
export class FormlyHorizontalWrapperComponent extends FieldWrapper {
}
